export default "{\n    \"confirmButtonLabel\": \"Confirmar\",\n    \"cancelButtonLabel\": \"Cancelar\"\n}\n"